import React, { useEffect } from "react";


const PageLoader = ({
  isPageLoading = false,
  messageforLoading = "Loading..."
}) => {
  
  useEffect(() => {
    if (isPageLoading) {
      document.body.classList.add("loading");
    } else {
      document.body.classList.remove("loading");
    }
  }, [isPageLoading]);

  return (
    isPageLoading && (
      <div className="page-loader">
        <div className="loader-content">
          <img src="Loader.gif" alt="Loading..." className="loader-gif" />
          
        </div>
      </div>
    )
  );
};

export default PageLoader;